import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/x-dots.svg'
import _imports_1 from '@/assets/imdex_x_green.svg'
import _imports_2 from '@/assets/imdex-logo-black.svg'


const _hoisted_1 = {
  class: "login-container",
  ref: "cccc"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%","height":"100%","object-fit":"cover","position":"absolute"},
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = { class: "login-box fadeInUp animated-med" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "x-logo",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "text-logo",
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mineportal-text" }, "MINEPORTAL", -1)
const _hoisted_7 = { class: "login-field" }
const _hoisted_8 = { class: "login-field" }
const _hoisted_9 = { class: "login-actions" }
const _hoisted_10 = { class: "login-btn" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", { style: {"width":"100%","border-color":"#f8fafb"} }, null, -1)
const _hoisted_12 = { class: "login-btn" }
const _hoisted_13 = { style: {"height":"50px"} }
const _hoisted_14 = {
  key: 0,
  class: "login-error animated-fast"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_support_request = _resolveComponent("support-request")!
  const _component_imdex_dialog = _resolveComponent("imdex-dialog")!
  const _component_imdex_text_field = _resolveComponent("imdex-text-field")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createVNode(_component_imdex_dialog, {
        width: "600",
        value: _ctx.supportRequestOpen,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.supportRequestOpen) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_support_request, {
            onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.supportRequestOpen = false))
          })
        ]),
        _: 1
      }, 8, ["value"]),
      _createElementVNode("form", {
        class: "login-form",
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitLogin && _ctx.submitLogin(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_imdex_text_field, {
            label: _ctx.$t('login.emailLabel'),
            value: _ctx.email,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
            leadingIcon: "fa fa-envelope"
          }, null, 8, ["label", "value"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/forgot'))),
            class: "login-forgot"
          }, _toDisplayString(_ctx.$t("login.forgotPassword")), 1),
          _createVNode(_component_imdex_text_field, {
            type: "password",
            label: _ctx.$t('login.passwordLabel'),
            value: _ctx.password,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.password) = $event)),
            leadingIcon: "fa fa-lock"
          }, null, 8, ["label", "value"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_imdex_btn, {
              block: "",
              type: "submit",
              loading: _ctx.isLoading,
              small: "",
              secondary: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("login.signIn")), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_imdex_btn, {
              block: "",
              onClick: _withModifiers(_ctx.login, ["prevent"]),
              outlined: "",
              small: "",
              secondary: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("login.signInWithSSO")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_Transition, {
              "enter-active-class": "fadeInUp",
              "leave-active-class": "fadeOutDown"
            }, {
              default: _withCtx(() => [
                (_ctx.errorMessage != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.errorMessage), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ], 32)
    ])
  ], 512))
}